export const ON_KEY_UP_RECORDING_ACTIVITY = 'ON_KEY_UP_RECORDING_ACTIVITY';
export const ON_KEY_DOWN_RECORDING_ACTIVITY = 'ON_KEY_DOWN_RECORDING_ACTIVITY';
